export default "__VITE_ASSET__DVuIRSAa__"